import { onlineManager } from '@tanstack/react-query';
import kitActionsRepositoryOfflineAdapters from '../../../offline/offlineRequestAdapters/kitActions.repository.offlineAdapters';
import { onlineKitActionRepository } from '../productActions/onlineKitActions.repository';

export const kitActionsRepository = (isOfflineMode = false) =>
  !isOfflineMode || onlineManager.isOnline()
    ? onlineKitActionRepository
    : kitActionsRepositoryOfflineAdapters;
